import { ImageFileName, ImagePath } from '../strict-strings';

export function geIImagePath(imgFileName: ImageFileName): ImagePath {
  return new ImagePath(`${process.env.PUBLIC_URL}/${process.env.REACT_APP_ASSETS_PATH}${imgFileName.valueOf()}`);
}
